<template>
  <div class="row margin-bottom-20">
    <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="activity-info-wrapper margin-bottom-20">
          <div class="img-wrapper" v-if="!isDashboard">
            <template v-if="sessionType === sessionTypes.INDIVIDUAL">
              <CustomEmblem 
                v-if="!activityInfo.playerPhoto"
                :gender="activityInfo.playerGender"
                :sub-header="[activityInfo.playerFirstName, activityInfo.playerLastName]" />

              <img v-if="activityInfo.playerPhoto" :src="activityInfo.playerPhoto" alt="player photo">
            </template>

            <template v-if="sessionType !== sessionTypes.INDIVIDUAL">
              <CustomEmblem 
                v-if="!activityInfo.teamLogo"
                :gender="activityInfo.teamGender"
                :sub-header="activityInfo.teamAgeGroup" />

              <img v-if="activityInfo.teamLogo" :src="activityInfo.teamLogo" alt="team logo">
            </template>
          </div>
          <div class="info padding-right-10" :class="{ 'padding-left-10': !isDashboard }">
            <div v-if="!isDashboard">
              <span class="text-white">
                {{activityInfo.teamName}}
              </span>
            </div>
            <div class="text-gray date-label">{{ activityInfo.started | dateLocale($i18n.locale, fullDateTimeFormat) }}</div>
          </div>
          <div class="duration-info" v-b-tooltip="activityInfo.sessionTooLong ? this.$t('CALENDAR_ACTIVITY.activityHeader.tooltipMessage') : ''">
            <div class="position-relative">
              <span class="duration-value">{{activityInfo.durationInSeconds | secondsToMinutesRoundedUp}}</span>
              <span class="unit-value">min</span>
              <img v-if="activityInfo.sessionTooLong" src="@/assets/images/activity/duration-icon-error.png" alt="duration icon">
              <img v-else src="@/assets/images/activity/duration-icon.png" alt="duration error icon">
            </div>
          </div>
        </div>

        <CalendarActivityInfo 
          v-if="sessionType !== sessionTypes.INDIVIDUAL" 
          :isDashboard="isDashboard"
          :activityInfo="activityInfo" />
    </div>
    <!-- share session from activity page uncomment-->
    
    <!-- <div class="share-session" v-if="sessionType == sessionTypes.INDIVIDUAL"><router-link :to="{name: 'ShareActivity'}" class="share-session-link"><i class="fa fa-share-alt-square" aria-hidden="true"></i>
 Share your session to Social media</router-link></div> -->

  </div>
</template>

<script>
import CustomEmblem from '@/components/common/CustomEmblem'
import CalendarActivityInfo from '@/components/calendar-activity/CalendarActivityInfo'
import { SESSION_TYPES } from '@/constants/SessionConsts'
import { FULL_DATE_TIME_FORMAT } from '@/constants/DateConstants'

export default {
  name: 'CalendarActivityHeader',
  props: [
    'activityId',
    'activityInfo',
    'sessionType',
    'isDashboard'
  ],
  data () {
    return {
      fullDateTimeFormat: FULL_DATE_TIME_FORMAT,
      sessionTypes: SESSION_TYPES,
    }
  },
  components: {
    CustomEmblem,
    CalendarActivityInfo
  }
}
</script>

<style lang="scss" scoped>
  .activity-info-wrapper {
    display: table;
    table-layout: fixed;

    .img-wrapper {
        display: table-cell;
        width: 80px;
        vertical-align: middle;

        img {
          max-width: 60px;
        }
    }

    .date-label {
      font-size: 14px;
    }

    .duration-info {
        display: table-cell;
        text-align: right;
        width: 40px;
        cursor: default;

        .duration-value, .unit-value {
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          top: 0;
          margin: auto;
          height: 14px;
          width: 100%;
          text-align: center;
          font-size: 14px;
        }

        .unit-value {
          font-size: 9px;
          bottom: -26px;
        }
    }

    .info {
      display: table-cell;
      vertical-align: middle;
    }

    .activity-btn {
      padding: 2px 6px;
      vertical-align: unset;
    }

    .activity-types-select-group {
      width: auto;

      .filter-btn {
          padding: 0 5px;
          height: 26px;
      }
    }
}

.share-session {
  margin: 15px;
  .share-session-link {
    color: $mid-gray;
    &:hover {
        color: $sea-buckthorn;
        text-decoration: none;
    }
    i {
      font-size: 30px;
    }
  }
}
</style>


